module.exports = __webpack_public_path__ + "img/chargingpoint-rejected.16636212.png";